module.exports = __webpack_public_path__ + "static/images/close.2UIG458.svg";